import { render, staticRenderFns } from "./editGoldLabel.vue?vue&type=template&id=afec3740&scoped=true"
import script from "./editGoldLabel.vue?vue&type=script&lang=js"
export * from "./editGoldLabel.vue?vue&type=script&lang=js"
import style0 from "./editGoldLabel.vue?vue&type=style&index=0&id=afec3740&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afec3740",
  null
  
)

export default component.exports